import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { AppService } from 'src/app/core/services/app.service';
import { ImageCropperService } from 'src/app/core/services/image-cropper.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { CCProcessors } from 'src/app/shared/models/enums/CCProcessors.enum';
import { UserRoleEnum } from 'src/app/shared/models/enums/user-role.enum';
import { OOVenue } from 'src/app/shared/models/oo-venue';
import { Store } from 'src/app/shared/models/store';

@Component({
	selector: 'app-payment-loyalty-setup',
	templateUrl: './payment-loyalty-setup.component.html',
	styleUrls: ['../../commandcenter.scss'],
})
export class PaymentLoyaltySetupComponent implements OnInit {
	changesToSave: boolean = false;
	clonedVenue: Store;
	clonedOOVenue: OOVenue;

	giftProcessors = [
		{ value: 0, label: 'None' },
		{ value: 1, label: 'MyFocus Gift' },
		{ value: 2, label: 'FocusGift Rest' },
	];

	loaded: boolean = false;
	loyaltyProcessors = [
		{ value: 0, label: 'None' },
		{ value: 1, label: 'FocusRewards' },
		{ value: 2, label: 'MyFocus Loyalty' },
	];

	moment: any = moment;

	timestamp;
	timezones: any[] = [];

	viewMode: number = 0;

	constructor(public app: AppService, private userService: UserService, public imgCrop: ImageCropperService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		this.timezones = moment.tz.zonesForCountry('US').map((tz) => ({
			label: tz,
			value: tz,
		}));
		this.clonedVenue = { ...this.venueSvc.subscriptionVenue.value };
		this.clonedOOVenue = { ...this.venueSvc.ooVenue };
	}

	async load() {}

	async onSave() {
		let venueChanged = false;
		Object.keys(this.venueSvc.subscriptionVenue.value).forEach((key) => {
			if (this.venueSvc.subscriptionVenue.value[key] !== this.clonedVenue[key]) {
				venueChanged = true;
			}
		});
		venueChanged && (await this.venueSvc.saveVenue());

		await this.venueSvc.ooVenueSave(this.venueSvc.ooVenue);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Payment & Loyalty settings saved` });
	}

	updateTimestamp() {
		this.timestamp = new Date().getTime();
	}
}
